import React from "react";
import { Star } from "lucide-react";
import { Fireflies } from "@/components/effects/Fireflies";
import { Reveal } from "@/components/effects/Reveal";
import { T } from "@/context/SiteContent";

export const Testimonials = ({ items }) => (
  <section id="stories" className="section relative overflow-hidden">
    <div className="section-tint section-tint-soft" />
    <Fireflies count={20} />
    <div className="container">
      <Reveal>
        <p className="eyebrow mb-4"><T k="testimonials.eyebrow" fallback="Stories from the bayou" /></p>
        <h2 className="font-serif text-5xl md:text-6xl tracking-tight max-w-3xl"><T k="testimonials.headline" fallback="Families who found the magic waiting." /></h2>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-2 gap-6">
        {items.map((t, i) => (
          <Reveal key={`${t.name}-${t.location}`} delay={i * 0.08}>
            <div className="glass p-8 hover:border-[#FFD166]/50 transition-colors" data-testid={`testimonial-${i}`}>
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => <Star key={`star-${j}`} className="w-4 h-4 fill-[#FFD166] text-[#FFD166]" />)}
              </div>
              <p className="font-serif text-2xl leading-snug">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-5 text-sm text-[#B9C8D5]">
                <span className="text-[#FFD166]">{t.name}</span> · {t.location}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
